











































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateSupplier from "./createsupplier.vue";
import EditSupplier from "./editsupplier.vue";
import "@/assets/css/table.css";
import checkAuth from "@/lib/Common/checkauth";
import Moment from "moment-timezone";

class PageUserRequest extends PageRequest {
  keyword: string;
  isEnabel: number = 9; //nullable
}

@Component({
  components: { CreateSupplier, EditSupplier },
})
export default class Supplier extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageUserRequest = new PageUserRequest();
  creationTime: Date[] = [];

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
    return this.$store.state.supplier.list;
  }
  get loading() {
    return this.$store.state.supplier.loading;
  }
  create() {
    this.createModalShow = true;
  }
  isActiveChange(val: string) {
    if (val === "Actived") {
      this.pagerequest.isEnabel = 1;
    } else if (val === "NoActive") {
      this.pagerequest.isEnabel = 0;
    } else {
      this.pagerequest.isEnabel = 9;
    }
    this.$store.commit("supplier/setCurrentPage", 1);
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("supplier/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("supplier/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "supplier/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.supplier.pageSize;
  }
  get totalCount() {
    return this.$store.state.supplier.totalCount;
  }
  get currentPage() {
    return this.$store.state.supplier.currentPage;
  }
  columns = [
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length == 0 ? this.L("Unknown") : info[0].displayName,
            },
          },
          info.length == 0 ? this.L("Unknown") : info[0].displayName
        );
      },
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.name,
            },
          },
          params.row.name
        );
      },
    },
    {
      title: this.L("Contacter"),
      key: "contacter",
      width: 130,
    },
    {
      title: this.L("Mobile"),
      key: "mobile",
      width: 130,
    },
    {
      title: this.L("Tel"),
      key: "tel",
      width: 130,
    },
    {
      title: this.L("Email"),
      key: "email",
      width: 130,
    },
    {
      title: this.L("Address"),
      key: "address",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.address,
            },
          },
          params.row.address
        );
      },
    },
    {
      title: this.L("SortName"),
      width: 90,
      key: "sortCode",
    },
    {
      title: this.L("IsActive"),
      render: (h: any, params: any) => {
        return h("span", params.row.isEnable ? this.L("Yes") : this.L("No"));
      },
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.creationTime == null
            ? ""
            : Moment(params.row.creationTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('supplierDel');
        let edit = this.checkButtonAuth('supplierEdit');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("supplier/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "supplier/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
  }
}
